import { Button, Modal, notification, Skeleton } from "antd";
import { useDispatch, useSelector } from "react-redux";
import React, { useContext, useEffect, useRef, useState } from "react";
import CustomForm from "../CustomForm";
import { userHasLevel } from "../../../engine/AuthRoute";
import { renderUserNameEmail, roles, subRoles } from "../../../utils/constants";
import { createPortal } from "react-dom";
import { confirmDeletebatch, modalsByContext } from "./modals";
import {
  getPrestation,
  setPropertiesPrestation,
  updateAdminPrestation,
} from "../../../pages/Prestations/Slices/Prestation.slice";
import { ModalContext } from "../../../engine/context/Modal.provider";
import { UserContext } from "../../../engine/context/User.context";
import { FiCheckCircle } from "react-icons/fi";
import { http } from "../../../engine/api/http";

export const PrestationGrouped = ({ defaultOpen }) => {
  const [open, setOpen] = useState(defaultOpen);
  const [listPrestations, setlistPrestations] = useState([]);
  const [ready, setReady] = useState(false);
  const [batch, setBatch] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setOpen(defaultOpen);
  }, [defaultOpen]);

  const { prestation, loadingEdit } = useSelector(state => state.prestation);

  const getListSamePrestations = async () => {
    try {
      const { data } = await http.post("/batchs/list-prestations", {
        prestationId: prestation._id,
      });
      setlistPrestations(data);
    } catch (e) {
      console.log(e);
    }
  };

  const getBatch = async () => {
    try {
      if (
        prestation.batch_grouped !== undefined &&
        prestation.batch_grouped !== null
      ) {
        const { data } = await http.get(
          `/batchs/${prestation.batch_grouped._id}`,
        );
        setBatch(data);
      } else {
        const { data } = await http.post(`/batchs/search`, {
          prestationId: prestation._id,
        });

        if (data !== null) {
          setBatch(data);
        }
      }
    } catch (e) {
      console.log(e);
    }
  };

  const getInitData = async () => {
    setLoading(true);
    await getListSamePrestations();
    await getBatch();
    setReady(true);
    setLoading(false);
  };

  useEffect(() => {
    getInitData();
  }, []);

  const inputs = prestationGroupedInputs(prestation, batch);

  const formRef = useRef(null);

  const context = useContext(ModalContext);
  const dispatch = useDispatch();
  const close = () => {
    setOpen(false);
    context.closeModal(modalsByContext.PrestationGrouped);
  };

  const deleteBatch = () => {
    setLoading(true);

    confirmDeletebatch({
      onOk: async () => {
        const deleted = await http.delete(`/batchs/${batch._id}`);
        notification.success({ message: "Groupe supprimé" });
        close();
        setLoading(false);
      },
    });
    setLoading(false);
  };

  const onSubmitForm = async data => {
    setLoading(true);

    // check if data.mainPrestation exist into data.prestations

    const control = data.prestations?.includes(data.mainPrestation);

    if (control === false || control === undefined) {
      notification.error({
        message:
          "La prestation principale doit être dans la liste des prestations",
      });
    } else {
      if (batch !== null) {
        // patch it
        const updated = await http.patch(`/batchs/${batch._id}`, data);
      } else {
        data.prestationId = prestation._id;
        data.type = "grouped";
        // create it
        const created = await http.post(`/batchs/new`, data);
      }
      await dispatch(getPrestation(prestation._id));
    }

    // await dispatch(setPropertiesPrestation(data));
    // let actionResult = await dispatch(updateAdminPrestation());
    setLoading(false);

    close();
  };

  const config = {
    key: prestation._id + modalsByContext.PrestationGrouped,
    containerStyle: { minWidth: "500px" },
    title: "Prestation groupée",
    open: open,
    onOk: () => {
      formRef.current.submit();
    },
    onCancel: close,
    content: (
      <>
        <CustomForm
          dataSource={inputs}
          handleSubmit={data => onSubmitForm(data)}
          labelCol={24}
          refForm={formRef}
          wrapperCol={24}
          onValuesChange={undefined}
        />
      </>
    ),
    footer: [
      <>
        {batch !== null && (
          <Button
            key="close"
            onClick={deleteBatch}
            type={"ghost"}
            danger={true}
          >
            Supprimer le groupe
          </Button>
        )}
      </>,
      <Button key="close" onClick={close}>
        Fermer
      </Button>,
      <Button
        icon={<FiCheckCircle size={20} />}
        type="primary"
        loading={loadingEdit || loading}
        disabled={loadingEdit}
        onClick={async () => {
          try {
            const test = await formRef.current.validateFields();
            formRef.current.submit();
          } catch (e) {
            notification.error({
              message: e.errorFields.length + " champs est nécessaire",
            });
          }
        }}
      >
        Sauvegarder
      </Button>,
    ],
  };

  return (
    <>
      {createPortal(
        <Modal {...config}>{ready ? config.content : <Skeleton />}</Modal>,
        document.querySelector("#modals"),
      )}
    </>
  );
};

export const prestationGroupedInputs = (prestation, batch) => {
  const {
    intervention: { startDate, endDate, location, extra },
    comment,
  } = prestation;

  return [
    {
      hidden: !userHasLevel({
        only: {
          [roles.admin]: "crud", //
          [roles.permanance]: "crud", //
        },
      }),
      children: [
        {
          label: "Prestations éligibles",
          name: "prestations",
          type: "dynamic-select",
          method: "POST",
          multiple: true,
          value: batch?.prestations || [],
          body: { prestationId: prestation._id },
          endPoint: "/batchs/list-prestations",
          itemCallback: item => {
            return {
              key: item._id,
              label: item.reference.toString(),
              value: item._id,
            };
          },
          row: 2,
          col: 24,
        },
        {
          label: "Prestation incluant les frais de déplacement",
          name: "mainPrestation",
          type: "dynamic-select",
          required: true,
          method: "POST",
          value: batch?.mainPrestation || undefined,
          multiple: false,
          body: { prestationId: prestation._id },
          endPoint: "/batchs/list-prestations",
          itemCallback: item => {
            const canceldAndNotBillable =
              item.status === "cancel" && item.bill === null;
            return {
              key: item._id,
              label: `${item.reference.toString()}  ${
                canceldAndNotBillable ? "Non facturée" : ""
              }`,
              value: item._id,
              disabled: canceldAndNotBillable,
            };
          },
          row: 2,
          col: 24,
        },
      ],
    },
  ];
};
